/**
 * 引数のOptional文字列が数値かどうかを判定する
 *
 * @param value Optionalな文字列
 * @returns true: 数値、false: 数値でない
 */
export const isNumericString = (value?: string) => {
  return value !== undefined && value !== null && !isNaN(Number(value));
};

/**
 * 姓・名などを全角スペースで結合する（null/undefined/空文字は除外）
 *
 * @param sei 姓
 * @param mei 名
 * @returns 全角スペース結合済み文字列
 */
export const joinName = (sei?: string | null, mei?: string | null): string =>
  [sei, mei].filter(Boolean).join('　');
